module.exports = __webpack_public_path__ + "static/media/tensorflow-logo.030c49b7.svg";